import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const s = {
  wrap:   { minHeight: '100vh', background: '#0a0a0f', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Inter, sans-serif' },
  card:   { background: '#16161f', border: '1px solid #1e1e2e', borderRadius: 20, padding: '40px 36px', width: '100%', maxWidth: 420 },
  logo:   { textAlign: 'center', fontSize: 28, marginBottom: 8 },
  title:  { textAlign: 'center', fontSize: 22, fontWeight: 700, color: '#e8e8f0', marginBottom: 6 },
  sub:    { textAlign: 'center', fontSize: 14, color: '#6b6b80', marginBottom: 32 },
  label:  { display: 'block', fontSize: 12, fontWeight: 600, color: '#6b6b80', marginBottom: 6 },
  input:  { width: '100%', background: '#0f0f17', border: '1px solid #1e1e2e', borderRadius: 10, padding: '12px 14px', color: '#e8e8f0', fontSize: 14, outline: 'none', boxSizing: 'border-box', marginBottom: 16 },
  btn:    { width: '100%', background: '#6c63ff', color: '#fff', border: 'none', borderRadius: 10, padding: '13px', fontSize: 15, fontWeight: 700, cursor: 'pointer', marginTop: 4 },
  error:  { background: 'rgba(255,101,132,0.1)', border: '1px solid rgba(255,101,132,0.3)', borderRadius: 8, padding: '10px 14px', fontSize: 13, color: '#ff6584', marginBottom: 16 },
  link:   { color: '#a29bfe', textDecoration: 'none', fontWeight: 600 },
  bottom: { textAlign: 'center', marginTop: 24, fontSize: 13, color: '#6b6b80' },
};

export default function Login() {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const { login }               = useAuth();
  const navigate                = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) return setError('Email ও password দিন');
    setError(''); setLoading(true);

    try {
      const user = await login(email, password);
      // Role অনুযায়ী redirect
      if (user.role === 'admin') navigate('/');
      else navigate('/client');
    } catch (err) {
      if (err.code === 'auth/user-not-found' || err.code === 'auth/wrong-password') {
        setError('Email বা password ভুল');
      } else if (err.code === 'auth/user-disabled') {
        setError('আপনার account block করা হয়েছে। Admin এর সাথে যোগাযোগ করুন।');
      } else if (err.response?.data?.message) {
        setError(err.response.data.message);
      } else {
        setError('Login failed। আবার চেষ্টা করুন।');
      }
    }
    setLoading(false);
  };

  return (
    <div style={s.wrap}>
      <div style={s.card}>
        <div style={s.logo}>🤖</div>
        <div style={s.title}>AI Ad Agency</div>
        <div style={s.sub}>আপনার account এ login করুন</div>

        {error && <div style={s.error}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <label style={s.label}>Email</label>
          <input style={s.input} type="email" placeholder="you@email.com"
            value={email} onChange={e => setEmail(e.target.value)} />

          <label style={s.label}>Password</label>
          <input style={s.input} type="password" placeholder="••••••••"
            value={password} onChange={e => setPassword(e.target.value)} />

          <button style={{ ...s.btn, opacity: loading ? 0.7 : 1 }} disabled={loading}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>

        <div style={s.bottom}>
          Account নেই? <Link to="/register" style={s.link}>Register করুন</Link>
        </div>
      </div>
    </div>
  );
}
